// src/utils/finestreAperte.js
// I pulsanti fissi in basso a destra (Azioni rapide «+» e Nexi) restavano SOPRA le finestre
// aperte (rapportino, sopralluogo…): sul telefono coprivano «Salva» e gli ultimi campi.
// Ora, finché è aperta una finestra (o il menu sul telefono), il corpo della pagina ha la classe
// «nx-finestra-aperta» e i pulsanti fissi (.nx-flottante) si nascondono (index.css).
// Un solo osservatore per tutta l'app; il controllo si fa al massimo una volta per fotogramma.
// Finestre con la classe .modal-overlay, il menu aperto sul telefono e le finestre scritte
// con lo sfondo a tutto schermo nello stile (position: fixed; inset: 0), che sono parecchie.
export const SELETTORE_FINESTRE = '.modal-overlay, .mobile-sidebar-wrapper.aperto, [style*="position: fixed"][style*="inset: 0px"]';

// Il pannello dell'attività conta come finestra solo quando è a tutto schermo (telefono):
// sul computer è un pannello a fianco dell'elenco, non copre niente (W404).
const PANNELLO = ".detail-panel";
const pannelloATuttoSchermo = (el) => { try { return getComputedStyle(el).position === "fixed"; } catch { return false; } };
/** Le finestre aperte in questo momento (comprese le attività a tutto schermo sul telefono). */
export function finestreAperte() {
  if (typeof document === "undefined") return [];
  return [...document.querySelectorAll(SELETTORE_FINESTRE), ...[...document.querySelectorAll(PANNELLO)].filter(pannelloATuttoSchermo)];
}

export function installaSegnaleFinestre() {
  if (typeof document === "undefined" || window.__nxSegnaleFinestre || typeof MutationObserver === "undefined") return;
  window.__nxSegnaleFinestre = true;
  let atteso = false;
  const controlla = () => {
    atteso = false;
    const aperta = finestreAperte().length > 0;
    document.body.classList.toggle("nx-finestra-aperta", aperta);
  };
  new MutationObserver(() => {
    if (atteso) return;
    atteso = true;
    (window.requestAnimationFrame || setTimeout)(controlla);
  }).observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ["class"] });
  controlla();
}
